import { useShowResponseStatus } from '@/shared';
import { useGetShopsQuery } from '@/modules/shops';

import type { TShopType } from '../store/types';

export const useGetShops = (type?: TShopType) => {
  const { data, isLoading, isError } = useGetShopsQuery();
  const filteredData = type ? data?.filter((shop) => shop.type === type) : data;

  useShowResponseStatus({
    isError,
    errorMassage: 'При получении списка магазинов произошла ошибка',
  });

  return {
    data: filteredData,
    isLoading,
  };
};
